import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";

export default function BotCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const guildId = params.get("guild_id");
    const state = params.get("state");
    const error = params.get("error");

    if (error) {
      alert(`Discord returned an error: ${error}`);
      navigate("/submit", { replace: true });
      return;
    }
    if (!guildId || !state) {
      alert("Bot install did not complete correctly. Try again.");
      navigate("/submit", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/servers/bot/register", {
          guild_id: guildId,
          state,
        });
        // Stash preview + publish token for SubmitServer to pick up
        sessionStorage.setItem("bot_preview", JSON.stringify(data));
        navigate("/submit", { replace: true });
      } catch (err) {
        alert(err?.response?.data?.detail || "Failed to register your server. Try again.");
        navigate("/submit", { replace: true });
      }
    })();
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#05050A]" data-testid="bot-callback-loading">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-2 border-blurple border-t-transparent rounded-full animate-spin" />
        <p className="text-zinc-400 font-mono text-sm">Verifying your server...</p>
      </div>
    </div>
  );
}
